import type { RouteObject } from "react-router-dom";
import { WorkflowHomePage } from "./pages/WorkflowHomePage";
import { WorkflowInboxPage } from "./pages/WorkflowInboxPage";
import FormsHomeHelp from "@/features/forms/help/forms-home.mdx";
import FormInstanceListHelp from "@/features/forms/help/form-instance-list.mdx";

/**
 * ADR-072 Rule FMS-01/FMS-03: این آرایه در router.tsx مرکزی spread می‌شود.
 * هیچ importی از features دیگر اینجا مجاز نیست.
 */
export const workflowRoutes: RouteObject[] = [
  {
    path: "help/workflow/home",
    element: <FormsHomeHelp />,
  },
  {
    path: "help/workflow/inbox",
    element: <FormInstanceListHelp />,
  },
  {
    path: "workflow",
    element: <WorkflowHomePage />,
  },
  {
    path: "workflow/inbox",
    element: <WorkflowInboxPage />,
  },
];
